import { MutationTree } from 'vuex';
import { IDocumentTracking } from '../types/document-tracking';
import { IClickTracking } from '../types/click-tracking';
import { IPageTracking } from '../types/page-tracking';
import { IVideoTracking } from '../types/video-tracking';
import { IVisitTracking } from '../types/visit-tracking';
import { ETrackingMutation, ITrackingState } from './tracking.types';
export const mutations: MutationTree<ITrackingState> = {
  [ETrackingMutation.SetLoaded](state: ITrackingState, loaded: boolean) {
    state.loaded = loaded;
  },
  [ETrackingMutation.SetLoading](state: ITrackingState, loading: boolean) {
    state.loading = loading;
  },
  [ETrackingMutation.SetState](state: ITrackingState, newState: ITrackingState) {
    Object.assign(state, newState);
  },
  [ETrackingMutation.SetTracking](state: ITrackingState, tracking: IDocumentTracking) {
    state.tracking = tracking;
  },
  [ETrackingMutation.SetSelectedRecipientId](state: ITrackingState, id: string) {
    state.selectedRecipientId = id;
  },
  [ETrackingMutation.AddClickTracking](state: ITrackingState, clickTracking: IClickTracking) {
    state.tracking.clickTrackings = [...state.tracking.clickTrackings, clickTracking];
  },
  [ETrackingMutation.SetPageTrackings](state: ITrackingState, pageTrackings: IPageTracking[]) {
    state.tracking.pageTrackings = pageTrackings;
  },
  [ETrackingMutation.AddVideoTracking](state: ITrackingState, videoTracking: IVideoTracking) {
    state.tracking.videoTrackings = [...state.tracking.videoTrackings, videoTracking];
  },
  [ETrackingMutation.AddVisitTimeTracking](
    state: ITrackingState,
    visitTimeTracking: IVisitTracking
  ) {
    state.tracking.visitTrackings = [...state.tracking.visitTrackings, visitTimeTracking];
  },
};
